import {findIndex} from "lodash";
import {DICTIONARY_TYPE} from "../constans/general";

export const initialValue = {
    race: {
        Type: DICTIONARY_TYPE.race,
        WData: [],
    },
    noPreganancy: {
        Type: DICTIONARY_TYPE.noPreganancy,
        WData: [],
    },
    graftingReason: {
        Type: DICTIONARY_TYPE.graftingReason,
        WData: [],
    },
    clients: {
        Type: DICTIONARY_TYPE.clients,
        WData: [],
    },
    fallReasons: {
        Type: DICTIONARY_TYPE.fallReasons,
        WData: [],
    },
    selectionReason: {
        Type: DICTIONARY_TYPE.selectionReason,
        WData: [],
    },
    weighting: {
        Type: DICTIONARY_TYPE.weighting,
        WData: [],
    },
    taskCategory: {
        Type: DICTIONARY_TYPE.taskCategory,
        WData: [],
    },
    files: {
        Type: DICTIONARY_TYPE.files,
        WData: [],
    },
    comments: {
        Type: DICTIONARY_TYPE.comments,
        WData: [],
    },
    crossBreeding: {
        Type: DICTIONARY_TYPE.crossBreeding,
        WData: [],
    },
    sellers: {
        Type: DICTIONARY_TYPE.sellers,
        WData: [],
    },
    sellReasons: {
        Type: DICTIONARY_TYPE.sellReason,
        WData: [],
    },
    fetching: false,
    controlLists: [],
    medicine: [],
    graftingPrograms: [],
    forageIngredients: [],
    automatedActions: [],
    taskStatuses: {
        Type: DICTIONARY_TYPE.taskStatus,
        WData: [],
    },
};

function splitDictionary(array) {
    let obj = {
        controlLists: [],
        medicine: [],
        graftingPrograms: [],
        forageIngredients: [],
        automatedActions: [],
    };
    for (let item of array) {
        switch (item.Type) {
            case DICTIONARY_TYPE.clients:
                obj.clients = item;
                break;
            case DICTIONARY_TYPE.sellers:
                obj.sellers = item;
                break;
            case DICTIONARY_TYPE.fallReasons:
                obj.fallReasons = item;
                break;
            case DICTIONARY_TYPE.noPreganancy:
                obj.noPreganancy = item;
                break;
            case DICTIONARY_TYPE.graftingReason:
                obj.graftingReason = item;
                break;
            case DICTIONARY_TYPE.race:
                obj.race = item;
                break;
            case DICTIONARY_TYPE.selectionReason:
                obj.selectionReason = item;
                break;
            case DICTIONARY_TYPE.weighting:
                obj.weighting = item;
                break;
            case DICTIONARY_TYPE.taskCategory:
                obj.taskCategory = item;
                break;
            case DICTIONARY_TYPE.files:
                obj.files = item;
                break;
            case DICTIONARY_TYPE.comments:
                obj.comments = item;
                break;
            case DICTIONARY_TYPE.crossBreeding:
                obj.crossBreeding = item;
                break;
            case DICTIONARY_TYPE.sellReason:
                obj.sellReasons = item;
                break;
            case DICTIONARY_TYPE.controlLists:
                obj.controlLists.push(item);
                break;
            case DICTIONARY_TYPE.medicine:
                obj.medicine.push(item);
                break;
            case DICTIONARY_TYPE.graftingProgram:
                obj.graftingPrograms.push(item);
                break;
            case DICTIONARY_TYPE.forageIngredient:
                obj.forageIngredients.push(item);
                break;
            case DICTIONARY_TYPE.automatedAction:
                obj.automatedActions.push(item);
                break;
            case DICTIONARY_TYPE.taskStatus:
                obj.taskStatuses = item;
                break;
            default:
                console.warn("Unknown dictionary type: ", item.Type);
                break;
        }
    }
    return obj;
}

function mergeArray(before, newArray) {
    let copy = before.slice();
    for (let row of newArray) {
        let index = findIndex(before, (o) => o.WordID === row.WordID);
        if (index === -1) {
            copy.push(row);
        } else {
            if (row.DtaDelTime) {
                copy.splice(index, 1);
            } else {
                copy[index] = row;
            }
        }
    }
    return copy;
}

export default function dictionaryReducer(state = initialValue, action) {
    switch (action.type) {
        case "GET_ALL_DICTIONARIES": {
            let obj = splitDictionary(action.payload);
            return {
                ...state,
                ...obj,
            };
        }
        case "LIST_DICTIONARY_PENDING":
        case "LIST_DEFAULT_DICTIONARY_PENDING":
        case "CREATE_DEVICE_PENDING":
        case "UPDATE_DICTIONARY_PENDING":
            return {...state, fetching: true};
        case "LIST_DICTIONARY_FULFILLED": {
            // akcja wywolywana w momencie pobierania nowych danych po przyjsciu trigerra mqtt
            // zrobione, aby listy kontrolne nie bagowaly sie po szybkim dodawaniu do ulubionych
            let obj = splitDictionary(action.payload);
            let controlList = mergeArray(state.controlLists, obj.controlLists);
            let medicines = mergeArray(state.medicine, obj.medicine);
            let graftingPrograms = mergeArray(
                state.graftingPrograms,
                obj.graftingPrograms
            );
            let forageIngredients = mergeArray(
                state.forageIngredients,
                obj.forageIngredients
            );
            let automatedActions = mergeArray(
                state.automatedActions,
                obj.automatedActions
            );
            delete obj.controlList;
            delete obj.medicines;
            delete obj.graftingPrograms;
            delete obj.forageIngredients;
            return {
                ...state,
                ...obj,
                fetching: false,
                controlLists: controlList,
                medicine: medicines,
                graftingPrograms,
                forageIngredients,
                automatedActions,
            };
        }
        case "LIST_DICTIONARY_REJECTED":
        case "LIST_DEFAULT_DICTIONARY_FULFILLED":
        case "LIST_DEFAULT_DICTIONARY_REJECTED":
        case "CREATE_DEVICE_REJECTED":
        case "CREATE_DEVICE_FULFILLED":
        case "UPDATE_DICTIONARY_REJECTED":
            return {...state, fetching: false};
        case "UPDATE_CONTROL_LIST":
            let controlLists = state.controlLists.slice(0);
            let index = findIndex(
                controlLists,
                (o) => o.WordID === action.payload.WordID
            );
            controlLists[index] = action.payload;
            return {...state, controlLists};
        case "STAR_CONTROL_LIST": {
            const copy = state.controlLists.slice(0);
            const index = findIndex(
                copy,
                (o) => o.WordID === action.meta.WordID
            );
            if (!Array.isArray(copy[index].WData.Favorite))
                copy[index].WData.Favorite = [];
            if (
                copy[index].WData.Favorite.includes(action.payload.LocalUserID)
            ) {
                copy[index].WData.Favorite = copy[index].WData.Favorite.filter(
                    (item) => item !== action.payload.LocalUserID
                );
            } else {
                copy[index].WData.Favorite.push(action.payload.LocalUserID);
            }
            copy.DtaModTime = +new Date();
            return {...state, controlLists: copy};
        }
        case "CLEAR_DICTIONARY":
        case "USER_LOGOUT_FULFILLED":
            return initialValue;
        default:
            return state;
    }
}
